@if (isLoaded) {
  <div class="container-fluid" [@fadeInAnimation]>
    <div class="row">
      <div class="col-xl-1"></div>
      <div class="col-xl-10">
        <div class="card mb-3">
          <div class="card-header">
            <arbetstagare-icon [arbetstagare]="anstallning.arbetstagare" color="#fff" size="lg" class="me-2"></arbetstagare-icon>{{ anstallning.arbetstagare.personNr12Siffror }} <span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.efternamn }}, {{ anstallning.arbetstagare.fornamn }}</span>
          </div>
          <div class="card-body">
            <p class="h5">Arbetstagarens kontaktuppgifter</p>
            <ul class="list-unstyled">
              <li><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.fornamn }} {{ anstallning.arbetstagare.efternamn }}{{ anstallning.arbetstagare.careof ? ' &#8453; ' + anstallning.arbetstagare.careof : '' }}</span></li>
              <li><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.gatuadress }}</span></li>
              <li class="mb-2"><span [class.redacted]="isConfidential">{{ anstallning.arbetstagare.postnummer }} {{ anstallning.arbetstagare.postort | uppercase }}</span></li>
              @if (!!anstallning.arbetstagare.telefon) {
                <li><span [class.redacted]="isConfidential"><b><fa-icon [icon]="['fas', 'phone']" size="sm" class="me-2"></fa-icon><a [href]="'tel:' + anstallning.arbetstagare.telefon">{{ anstallning.arbetstagare.telefon }}</a></b></span></li>
              }
              @if (!!anstallning.arbetstagare.epost) {
                <li><span [class.redacted]="isConfidential"><b><fa-icon [icon]="['fas', 'at']" size="sm" class="me-2"></fa-icon><a [href]="'mailto:' + anstallning.arbetstagare.epost">{{ anstallning.arbetstagare.epost | lowercase }}</a></b></span></li>
              }
              @if (!!anstallning.not1 || !!anstallning.not2 || !!anstallning.not3) {
                <li class="mt-2">
                  <ul class="list-unstyled ms-3">
                    @if (!!anstallning.not1) {
                      <li class="badge rounded-pill badge-notis">{{ anstallning.not1 }}</li>
                    }
                    @if (!!anstallning.not2) {
                      <li class="badge rounded-pill badge-notis">{{ anstallning.not2 }}</li>
                    }
                    @if (!!anstallning.not3) {
                      <li class="badge rounded-pill badge-notis">{{ anstallning.not3 }}</li>
                    }
                  </ul>
                </li>
              }
            </ul>
            @if (!!anstallning.kommentar) {
              <div class="alert alert-light"><pre>{{ anstallning.kommentar }}</pre></div>
            }
            <hr />
            <p class="h5">Arbetstagarens beslut</p>
            @if (anstallning.lonegarantiBeslut.length) {
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" [class.order-active]="orderName==='beslutTyp'" (click)="setOrder('beslutTyp', ['beslutTyp.typ'])" style="width: 80px">
                        <div class="d-flex justify-content-between">
                          Typ
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='datum'" (click)="setOrder('datum', ['datum'])" style="width: 120px">
                        <div class="d-flex justify-content-between">
                          Datum
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='period'" (click)="setOrder('period', ['periodFrom', 'periodTom'])">
                        <div class="d-flex justify-content-between">
                          Period
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='lgBelopp'" class="text-right-sm-left" (click)="setOrder('lgBelopp', ['lgBeloppTotal_cache'])">
                        <div class="d-flex justify-content-between">
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="me-2" [flip]="reverse||'vertical'"></fa-icon>
                          Lönegaranti
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='fordranBelopp'" class="text-right-sm-left" (click)="setOrder('fordranBelopp', ['fordranBeloppTotal_cache'])">
                        <div class="d-flex justify-content-between">
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="me-2" [flip]="reverse||'vertical'"></fa-icon>
                          Fordran
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='harFil'" (click)="setOrder('harFil', ['harFil'])" style="width: 140px">
                        <div class="d-flex justify-content-between">
                          Dokument
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" class="text-center-sm-left" style="width:160px">Signatur</th>
                      @if (role==='adv') {
                        <th scope="col" class="text-center-sm-left" style="width:45px">Vald</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (c of anstallning.lonegarantiBeslut | orderBy: order:reverse:'case-insensitive'; track c) {
                      <tr [class.active]="c.isSelected">
                        <td data-name="Typ" title="Beslutstyp"><beslut-icon [arendeTyp]="anstallning.arende.arendeTyp" [beslutTyp]="c.beslutTyp"></beslut-icon></td>
                        <td data-name="Datum" title="Beslutsdatum">{{ c.datum | localizeddate:'shortDate' }}</td>
                        <td data-name="Period" title="Period">{{ c.periodFrom | localizeddate:'shortDate' }} &ndash; {{ c.periodTom | localizeddate:'shortDate' }}</td>
                        <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left">{{ c.lgBeloppTotal_cache | localizednumber }} kr</td>
                        <td data-name="Fordran" title="Fordran i kronor" class="text-right-sm-left">{{ c.fordranBeloppTotal_cache | localizednumber }} kr</td>
                        <td data-name="Dokument" class="beslut-file">
                          @if (c.beslutTyp.typ!=='b2') {
                            <file-link [file]="c.fil"></file-link>
                          }
                          @if (c.beslutTyp.typ==='b2') {
                            <individual-b2-link [beslut]="c"></individual-b2-link>
                          }
                        </td>
                        <td data-name="Signatur" class="text-center-sm-left">
                          @if (((c.beslutTyp.typ==='b2' ? $safeNavigationMigration(c.huvudB2?.fil?.filtillagg) : $safeNavigationMigration(c.fil?.filtillagg)) | lowercase)==='.pdf') {
                            <signature-icon [signature]="c.beslutTyp.typ==='b2' ? $safeNavigationMigration(c.huvudB2?.fil?.signatur) : $safeNavigationMigration(c.fil?.signatur)"></signature-icon>
                          }
                        </td>
                        @if (role==='adv' && ((c.beslutTyp.typ==='b2' ? $safeNavigationMigration(c.huvudB2?.fil?.filtillagg) : $safeNavigationMigration(c.fil?.filtillagg)) | lowercase)==='.pdf') {
                          <td data-name="Vald" title="Vald" class="text-center-sm-left">
                            @if (c.beslutTyp.typ!=='b2') {
                              <div class="mb-0">
                                <div class="checkbox">
                                  <label class="mb-0">
                                    <input type="checkbox" class="form-check-input" [checked]="!!c.isSelected || c.fil?.signatur" [disabled]="$safeNavigationMigration(c.fil?.signatur)" (change)="c.isSelected = !c.isSelected">
                                    <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                                  </label>
                                </div>
                              </div>
                            }
                            @if (c.beslutTyp.typ==='b2' && c.huvudB2?.fil?.signatur) {
                              <div class="mb-0">
                                <div class="checkbox">
                                  <label class="mb-0">
                                    <input type="checkbox" class="form-check-input" checked disabled>
                                    <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                                  </label>
                                </div>
                              </div>
                            }
                          </td>
                        }
                        @if (role==='adv' && ((c.beslutTyp.typ==='b2' ? $safeNavigationMigration(c.huvudB2?.fil?.filtillagg) : $safeNavigationMigration(c.fil?.filtillagg)) | lowercase)!=='.pdf') {
                          <td></td>
                        }
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <th data-name="Antal beslut" title="Antal beslut" colspan="3">{{ anstallning.lonegarantiBeslut.length | localizednumber }} st</th>
                      <th data-name="Total lönegaranti" title="Total lönegaranti i kronor" class="text-right-sm-left">{{ getSum(anstallning.lonegarantiBeslut, 'lgBeloppTotal_cache') | localizednumber }} kr</th>
                      <th data-name="Total fordran" title="Total fordran i kronor" class="text-right-sm-left">{{ getSum(anstallning.lonegarantiBeslut, 'fordranBeloppTotal_cache') | localizednumber }} kr</th>
                      <th></th>
                      <th></th>
                      @if (role==='adv') {
                        <th></th>
                      }
                    </tr>
                  </tfoot>
                </table>
              </div>
            }
            @if (role==='adv' && harBeslutKvarAttSignera) {
              <div class="container-fluid">
                <div class="row">
                  <sign [files]="selectedFiles" (onSuccess)="reloadAnstallning()" class="d-flex w-100" btnClass="btn-garanti btn-blue ms-auto"></sign>
                </div>
              </div>
            }
            @if (!anstallning.lonegarantiBeslut.length) {
              <p class="text-muted">Inga beslut</p>
            }
            <hr />
            <p class="h5">Arbetstagarens bilagor</p>
            @if (bilagors.length) {
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col" style="width:120px">Datum</th>
                      <th scope="col">Beskrivning</th>
                      <th scope="col" style="width:140px">Dokument</th>
                      <th scope="col" class="text-center-sm-left" style="width:160px">Signatur</th>
                      @if (role==='adv') {
                        <th scope="col" class="text-center-sm-left" style="width:45px">Vald</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (d of bilagors | orderBy: ['-datumSparat', 'beskrivning']; track d) {
                      <tr>
                        <td data-name="Datum" title="Datum">{{ d.datumSparat | localizeddate:'shortDate' }}</td>
                        <td data-name="Beskrivning" title="Beskrivning">{{ d.beskrivning }}</td>
                        <td data-name="Dokument" title="Dokument" class="beslut-file"><file-link [file]="d"></file-link></td>
                        <td data-name="Signatur" class="text-center-sm-left">
                          @if ((d.filtillagg | lowercase)==='.pdf') {
                            <signature-icon [signature]="d.signatur"></signature-icon>
                          }
                        </td>
                        @if (role==='adv' && (d.filtillagg | lowercase)==='.pdf') {
                          <td data-name="Vald" title="Vald" class="text-center-sm-left">
                            <div class="mb-0">
                              <div class="checkbox">
                                <label class="mb-0">
                                  <input type="checkbox" class="form-check-input" [checked]="!!d.isSelected || d.signatur" [disabled]="d.signatur" (change)="d.isSelected = !d.isSelected">
                                  <span class="cr"><fa-icon [icon]="['fas', 'check']" transform="grow-3" class="cr-icon"></fa-icon></span>
                                </label>
                              </div>
                            </div>
                          </td>
                        }
                        @if (role==='adv' && (d.filtillagg | lowercase)!=='.pdf') {
                          <td></td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
            @if (!bilagors.length) {
              <p class="text-muted">Inga bilagor</p>
            }
            @if (role==='adv' && harBilagorKvarAttSignera) {
              <div class="container-fluid">
                <div class="row">
                  <sign [files]="selectedFiles" (onSuccess)="reloadAnstallning()" class="d-flex w-100" btnClass="btn-garanti btn-blue ms-auto"></sign>
                </div>
              </div>
            }
            <a [routerLink]="['/mina-arenden', anstallning.arende.id]" class="btn-garanti btn-blue mt-3"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Tillbaka till ärendet</a>
          </div>
        </div>
      </div>
    </div>
  </div>
}
